import React from 'react';
import LandingPageView from 'views/public/LandingPageView';
import i18next from 'i18next';
import LayoutContainer from 'containers/LayoutContainer';

const LandingPage = () => {
  return (
    <LayoutContainer isPublic title={i18next.t<string>('PUBLIC_PROCEDURES_VIEW:TITLE')}>
      <LandingPageView />
    </LayoutContainer>
  );
};

export default LandingPage;
